<script>
import axios from "axios";
import Layout from "../../layouts/auth";
import router from '../../index'
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters,mapActions } from "vuex"
/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Select Business",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    ModelListSelect
  },
  data() {
    return {
      businessError:"",
      branchError:"",
      loginError:"",
      loginStatus:false,
    
      data:{
        username: localStorage.getItem("username"),
        business: '',   
        branch: '',   
      },
      BranchesArr:''
    };
  },
  computed: {
    ...mapGetters("auth", ["Business", "AllBranches"]),
  },
  methods: {
    Login(){
      this.loginStatus=true;
      if (this.data.business == ''){
        this.businessError="Business Field is required";
        this.loginStatus=false;
        return;
      }else {
        this.businessError="";
      }
      if (this.data.branch == ''){
        this.branchError="Branch Field is required";
        this.loginStatus=false;
        return;
      }else {
        this.branchError="";
      }
      axios.post('login', this.data).then(response => {
        if (response.status==200){
          localStorage.removeItem('username');
          localStorage.setItem("token", response.data.token)
          const token = response.data.token
          localStorage.setItem('token', token);
          this.$store.commit("auth/setLoggedIn", response.data);
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;  
          localStorage.removeItem('identifier')
          router.push('/');
        }else {
          this.loginError="Logging in failed. Try again";
        }
      }).catch(()=>{
        this.loginError="Logging in failed. Try again";
      })
    },

    CheckBranches(){
      let selectedBranches = this.AllBranches.filter((item)=>{
          return item.business_id == this.data.business;
      })
      this.BranchesArr = selectedBranches;
      this.data.branch = selectedBranches?selectedBranches[0].id:[];
    },

    ...mapActions({
      FetchBusiness: "auth/fetchBusinesses",
      FetchAllBranches: "auth/fetchAllBranches",
    }),    

    resetError(){
      this.businessError = "",
      this.branchError = ""
    }
  },

  created() {
    this.FetchBusiness();
    this.FetchAllBranches();
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">

          <div class="card-body pt-0">
            <div>
                <div class="row">
                  <div class="col-md-2">
                    <div class="avatar-md profile-user-wid mt-3">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.png" alt height="40" />
                  </span>

                    </div>
                  </div>
                  <div class="col-md-10 mb-5">
                    <div class="text-primary p-4">
                      <h4 class="text-primary">SET BUSINESS TO LOGIN</h4>
                    </div>
                  </div>
                </div>
            </div>
          
            <!-- create new password -->
            <div class="p-2 mb-5" id="password-card" style="display: block">
              <form @submit.prevent="Login">                
                <div class="mb-3">
                  <label for="userEmail">Select Business</label>
                  <model-list-select
                    :list="Business ? Business : []"
                    v-model="data.business"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select business"
                    @input="resetError(), CheckBranches()"
                  >
                  </model-list-select>
                  <div class="text-danger" v-if="businessError">
                    <em>{{businessError }}</em>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="userEmail">Select Branch</label>
                  <model-list-select
                    :list="BranchesArr ? BranchesArr : []"
                    v-model="data.branch"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select branch"
                    @input="resetError()"
                  >
                  </model-list-select>
                  <div class="text-danger" v-if="branchError">
                    <em>{{branchError }}</em>
                  </div>
                </div>
                <div class="mt-3 d-grid">
                  <b-button type="submit" variant="warning" class="btn-block">
                    Login
                    <b-spinner v-if="loginStatus==true" variant="light" small role="status"></b-spinner>
                  </b-button>
                  <div class="text-danger" v-if="loginError">
                    <em>{{loginError }}</em>
                  </div>
                </div>
              </form>
            </div>
            <!-- end create new password -->
        </div>

        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} Production System
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
